import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mb-5" }
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = {
  key: 1,
  class: "row"
}
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && _ctx.invoice && !_ctx.has_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header" }, "Invoice Request", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.invoice.user.first_name) + " " + _toDisplayString(_ctx.invoice.user.last_name), 1),
                      _createElementVNode("p", _hoisted_9, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.invoice.user.job_title), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.invoice.user.company_name), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Payment Amount:", -1)),
                        _createTextVNode(" $" + _toDisplayString(_ctx.invoice.payment_amount), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Invoice Requested:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.moment(_ctx.invoice.invoice_requested_at).format('MM/DD/YYYY')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[6] || (_cache[6] = _createElementVNode("h4", null, "Contact Information", -1)),
                      _createElementVNode("p", null, _toDisplayString(_ctx.invoice.user.email), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.invoice.user.address_1), 1),
                      (_ctx.invoice.user.address_2 != null)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.invoice.user.address_2), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.invoice.user.city) + ", ", 1),
                        (_ctx.invoice.user.state != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.invoice.user.state.short_name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.invoice.user.zip), 1)
                    ])
                  ]),
                  (_ctx.invoice.is_payment_made)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("p", null, "Payment was submitted on " + _toDisplayString(_ctx.moment(_ctx.invoice.payment_made_at).format('MM/DD/YYYY')) + ".", 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.show_complete_modal = true;})
                          }, "Mark As Paid")
                        ])
                      ]))
                ])
              ])
            ])
          ])
        ]))
      : (_ctx.has_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      modelValue: _ctx.show_complete_modal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show_complete_modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[8] || (_cache[8] = [
        _createTextVNode("Mark As Paid")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show_complete_modal = false)),
          class: "btn btn-default mx-2"
        }, "Cancel"),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.markAsPaid && _ctx.markAsPaid(...args))),
          class: "btn btn-primary"
        }, "Mark As Paid")
      ]),
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("div", null, [
          _createElementVNode("p", null, "Are you sure you would like to mark this invoice as paid?"),
          _createElementVNode("p", { class: "text-danger" }, [
            _createElementVNode("strong", null, "Invoices should only be marked as paid if payment was received. This action cannot be undone.")
          ])
        ], -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}